var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5359 508.793C35.9831 509.523 23.6379 505.35 14.1035 497.154C-4.70019 478.238 -4.70019 447.688 14.1035 428.773L425.842 17.0325C445.4 -1.26805 476.089 -0.250734 494.389 19.3067C510.938 36.9925 511.903 64.1759 496.647 82.9891L82.4828 497.154C73.0714 505.232 60.9242 509.397 48.5359 508.793Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M459.791 508.793C447.069 508.739 434.875 503.689 425.842 494.73L14.1018 82.9876C-3.31886 62.6443 -0.950431 32.0289 19.3928 14.6066C37.5497 -0.942244 64.3274 -0.942244 82.4827 14.6066L496.647 426.347C516.2 444.652 517.211 475.343 498.906 494.896C498.177 495.673 497.425 496.426 496.647 497.154C486.506 505.973 473.16 510.187 459.791 508.793Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/closeWhite.24fc40253ddb1390845a6c821171b308.svg";
export { ForwardRef as ReactComponent };